import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Button,
  Container,
  Dimmer,
  Grid,
  Header,
  Icon,
  Loader,
  Segment,
} from 'semantic-ui-react';
import axios from 'axios';

import Dashboard from './Dashboard';

import { useAuth, useError } from '../providers';

const Activate = () => {
  const [activated, setActivated] = useState(false);
  const [loading, setLoading] = useState(true);

  const { showError } = useError();
  const { user, authenticated, login } = useAuth();
  let { token } = useParams();

  useEffect(() => {
    const activate = async () => {
      try {
        const { data } = await axios.post(
          '/api/activate',
          { token }
        );

        switch (data.status) {
          case 200: // Save was successful.
            setActivated(true);
            break;
          default:  // Anything else
            break;
        }
        setTimeout(() => setLoading(false), 1000);
      } catch (err) {
        showError(<center>An unknown error occured while trying to Activate.</center>);
      }
    }

    if (authenticated) {
      activate();
    }
  }, [authenticated, token, showError]);

  if (authenticated) {
    return (
      <Segment className='lobby' inverted>
        <Dimmer active={loading}>
          <Loader indeterminate>
            Activating...
          </Loader>
        </Dimmer>
        {(activated) ?
          <Dashboard additional={
            <React.Fragment>
              <p>
                You have successfully activated the mod!
              </p>
              <p>
                Now that you are connected, give your chat the following help link, that will be customized based on how you configure commands: <a href={`/help/${user['username']}`}>https://{window.location.hostname}/help/{user['username']}</a>. This link is available to your chat via the <code>!help</code> command in chat, however if you have follower only chat, or block links from being posted, then the bot may struggle to share this page with your community.
              </p>
              <p>
                You can use the following sections to customize your instance of the Twitching of Isaac; if you need any help, don't hesitate to visit the Discord via the link below!
              </p>
              <p>
                You can switch back to your game now!
              </p>
            </React.Fragment>
          } />
          :
          <Container text className='description' style={{ display: loading ? 'none' : 'block' }}>
            <Header as='h2' inverted>
              <Icon name='exclamation circle' color='red' />
              Activation Failed!
            </Header>
            <p>
              There was an issue activating. Please visit the <a href='https://discord.gg/FtJyJNcz2k'>Discord</a> for assistance!
            </p>
          </Container>
        }
      </Segment>
    );
  } else {
    return (
      <React.Fragment>
        <Grid textAlign='center' style={{ height: '35vh' }} verticalAlign='middle'>
          <Grid.Column style={{ maxWidth: 450 }}>
            <p>
              <strong style={{ color: '#fff' }}>Please login to Twitch to activate the mod!</strong>
            </p>
            <Button onClick={login} style={{ color: '#fff', backgroundColor: '#9146FF' }} fluid size='large'>
              <i class="icon twitch"></i>
              Login with Twitch
            </Button>
          </Grid.Column>
        </Grid>
      </React.Fragment>
    )
  }
};

export default Activate;
